module.exports = new __parcel__URL__("plans-standard-dark.fce82c99.svg").toString();